import { makeStyles } from '@material-ui/core/styles';

export const useBulkAIButtonStyles = makeStyles(theme => ({
  buttonContainer: {
    margin: theme.spacing(1, 1, 1, 0)
  }
}));
